export default "__VITE_ASSET__43ce5cde__"